import { ROUTES } from "@ane/exp-data/lib/routes/Routes.constants";
class FlightSearchUtils {
  parseDto(flightSearchResponse) {
    const { Results = [] } = flightSearchResponse || {};
    if (!Results) {
      return [];
    }
    return Results.map((r) => {
      return {
        flightName: r.FlightName,
        description: r.Description,
        isStandardControl: r.IsStandardControl,
        managementGroup: r.ManagementGroup,
        isolationGroups: r.IsolationGroups
      };
    });
  }
  getFlightUrl(flightName, managementGroup) {
    if (!flightName) {
      return "";
    }
    return `${ROUTES.flightDetails.location.pathname}/${flightName}${!!managementGroup ? `?managementGroup=${managementGroup}` : ""}`;
  }
}
const FlightSearchUtils$1 = new FlightSearchUtils();
export {
  FlightSearchUtils,
  FlightSearchUtils$1 as default
};
//# sourceMappingURL=FlightSearchUtils.js.map
